import { Group, Text } from '@mantine/core'
import { ReactNode } from 'react'
import { useIntl } from 'react-intl'
import { CompactSlider } from '@/components/ui-shared/CompactSlider/CompactSlider'

const MIN_VALUE = 0.3
const MAX_VALUE = 1
const STEP = 0.1
const DEFAULT_VALUE = 0.5
const DEFAULT_LABEL_WIDTH = 100

type ConfidenceSelectorProps = {
  label: string | ReactNode
  value: number
  isUpperCase?: boolean
  labelWidth?: number
  onChange: (value: number) => void
}

export const ConfidenceSelector = ({
  label,
  value,
  labelWidth = DEFAULT_LABEL_WIDTH,
  isUpperCase = true,
  onChange
}: ConfidenceSelectorProps) => {
  const intl = useIntl()

  return (
    <Group w="100%" wrap="nowrap">
      <Text
        miw={labelWidth}
        size="xs"
        fw="bold"
        styles={{
          root: {
            textTransform: isUpperCase ? 'uppercase' : 'none'
          }
        }}
      >
        {label}
      </Text>

      <CompactSlider
        w="100%"
        marks={[
          {
            value: MIN_VALUE,
            label: intl.formatMessage({ id: 'events.confidence.low' })
          },
          {
            value: MAX_VALUE,
            label: intl.formatMessage({ id: 'events.confidence.high' })
          }
        ]}
        value={value}
        min={MIN_VALUE}
        max={MAX_VALUE}
        step={STEP}
        defaultValue={DEFAULT_VALUE}
        onChange={onChange}
      />
    </Group>
  )
}
